import React, { Component } from 'react';
import PropTypes from 'prop-types';
import qs from 'qs';
import { withRouter } from 'react-router-dom';

/**
 * hoc для автоматизации управления универсальным reducer list и состоянием location search
 * - при изменении в store подготовленных параметров к отправке запроса, компонент вызывает запрос
 * - при изменении location search компонент меняет параметры запроса в store и вызывает запрос
 * */
export default function createGroup(WrappedComponent) {
  class GroupsSearchCollector extends Component {
    constructor(props) {
      super(props);
      this.groupQueryParams = qs.parse(this.props.location.search.slice(1));
    }

    setGroupQueryParamsAndUpdateHistory = (queryParams, groupName) => {
      this.groupQueryParams = {
        ...this.groupQueryParams,
        ...{ [groupName]: queryParams }
      };
      this.updateHistory();
    };

    removeGroupQueryParamsAndUpdateHistory = groupName => {
      delete this.groupQueryParams[groupName];
    };

    updateHistory = () =>
      this.context.router.history.push({
        pathname: this.props.location.pathname,
        search: `?${qs.stringify(this.groupQueryParams)}`
      });

    render() {
      return (
        <WrappedComponent
          {...this.props}
          searchString={`?${qs.stringify(this.groupQueryParams)}`}
          setGroupQueryParamsAndUpdateHistory={
            this.setGroupQueryParamsAndUpdateHistory
          }
          removeGroupQueryParamsAndUpdateHistory={
            this.removeGroupQueryParamsAndUpdateHistory
          }
        />
      );
    }
  }
  GroupsSearchCollector.displayName = `GroupsSearchCollector`;
  GroupsSearchCollector.propTypes = {
    location: PropTypes.shape({
      search: PropTypes.string.isRequired,
      pathname: PropTypes.string.isRequired
    }).isRequired
  };
  GroupsSearchCollector.contextTypes = {
    router: PropTypes.shape()
  };
  return withRouter(GroupsSearchCollector);
}



// WEBPACK FOOTER //
// ./src/components/Hocs/GroupsSearchNewCollector/GroupsSearchCollector.js